module.exports = __webpack_public_path__ + "img/button_home.7cb15b1c.svg";